import { MessageTypes } from "./../constants/ActionTypes";
const Messages = (messages = [], action) =>
{

  let temp = [...messages];

  // Arbitrary max length of temporary view
  if (temp.length >= 100) temp.pop();

  /* 
    Literally the only difference between POST_MESSAGE and NEW_MESSAGE
    is what causes them to trigger, should probably consolidate them
    into one term

    POST_MESSAGE fires when the client itself creates a new message object
    while NEW_MESSAGE fires whenever a new message is received from the websocket
    connection, meaning someone else has posted a new message object
  */
  switch (action.type)
  {
    case MessageTypes.FETCH_ALL:
      return [...action.payload, ...temp];
    case MessageTypes.POST_MESSAGE:
      return [action.payload, ...temp];
    case MessageTypes.NEW_MESSAGE:
      return [action.payload, ...temp];
    default:
      return temp;
  }
}

export default Messages;